/**
 * URL route constants for the App Updates application
 */

export const ROUTES = {
  /**
   * Base route for the app updates list page (the "All changes" tab)
   */
  RELEASE_NOTES: '/release-notes',

  /**
   * Route for the app updates list page with the "Release tracks changes" tab active
   */
  RELEASE_TRACKS_CHANGES: '/release-notes/release-tracks-changes',

  /**
   * Legacy route for the Release tracks changes tab. Keep this redirect path
   * working for existing customer links.
   */
  LEGACY_BUNDLED_CHANGES: '/release-notes/bundled-changes',

  /**
   * Route for app update details page
   * @param id - The update ID
   * @returns The complete route path
   */
  RELEASE_NOTE_DETAILS: (id: string) => `/release-notes/${id}`,
} as const;
